import { defineStore } from 'pinia';

import { fetchWrapper, baseUrl } from '@/helpers';

export const useUserPreferenceStore = defineStore({
	id: 'userPreference',
	state: () => ({
		userPreferences: {}
	}),
	actions: {
		async getAllUserPreferences() {
			const response = await fetchWrapper.get(`${baseUrl}/session/preferences`);
			this.userPreferences = response.data;
		},
		async getUserPreference(preferenceName) {
			const response = await fetchWrapper.get(`${baseUrl}/session/preferences/${preferenceName}`);
			this.userPreferences[preferenceName] = response.data.value;
		},
		async setUserPreference(preferenceName, preferenceValue) {
			await fetchWrapper.put(`${baseUrl}/session/preferences/${preferenceName}`, {
				value: preferenceValue
			});
			await this.getUserPreference(preferenceName);
		}
	}
});
